import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 223 223",
  "content": "<symbol viewBox=\"0 0 223 223\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<path d=\"M155.027 108.789C157.014 109.947 157.014 112.817 155.027 113.974L91.2104 151.139C89.2104 152.304 86.7006 150.861 86.7006 148.547V74.217C86.7006 71.9025 89.2104 70.4598 91.2104 71.6245L155.027 108.789Z\" fill=\"white\" />\n<circle cx=\"111.382\" cy=\"111.382\" r=\"101.382\" stroke=\"white\" stroke-width=\"20\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol